import Certificate from './certificate';

const templates = [
  {
    id: 'ROBO_2019_CERT',
    label: 'Document',
    template: Certificate,
  },
];

export default templates;
